(() => {
  let EXPIRY_DAYS = 10;

  if (document.querySelector("[data-wishlist-expiry-days]")) {
    try {
      EXPIRY_DAYS = parseInt(
        document.querySelector("[data-wishlist-expiry-days]").dataset
          .wishlistExpiryDays,
        10
      );
    } catch (e) {
      console.error("Error getting wishlist expiry days:", e);
    }
  }

  const checkWishlistExpiry = () => {
    try {
      const wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
      const now = new Date();

      const updatedWishlist = wishlist.filter((item) => {
        const addedAt = new Date(item.addedAt);
        const daysDiff = (now - addedAt) / (1000 * 60 * 60 * 24);
        return daysDiff < EXPIRY_DAYS;
      });

      if (updatedWishlist.length !== wishlist.length) {
        localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));

        // Dispatch storage event to notify other components
        window.dispatchEvent(
          new StorageEvent("storage", {
            key: "wishlist",
            newValue: JSON.stringify(updatedWishlist),
          })
        );
      }
    } catch (e) {
      console.error("Error checking wishlist expiry:", e);
    }
  };

  // Check on page load
  checkWishlistExpiry();

  // Listen for wishlist changes
  window.addEventListener("storage", (event) => {
    if (event.key === "wishlist") {
      checkWishlistExpiry();
    }
  });
})();
